import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=77ccadcf"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=77ccadcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports